import React from "react";
import PropTypes from "prop-types";
import TextField from "material-ui/TextField";
import RaisedButton from "material-ui/RaisedButton";
import FloatingActionButton from "material-ui/FloatingActionButton";
import IconAdd from "material-ui/svg-icons/content/add-circle-outline";
import _ from "lodash";
import NormalBigButton from "../../../components/common/NormalBigButton";
import ActionButton from "../../../components/common/ActionButton";
import ContentNode from "./ContentNode";
import CategoryLibrary from "./CategoryLibrary";
import InstructionLibrary from "./InstructionLibrary";
import colors from "../../../styles/colors";
import Dialog from "material-ui/Dialog";
import FlatButton from "material-ui/FlatButton";
import Title from "../../../components/common/Title";
import AutoComplete from "material-ui/AutoComplete";
import sort from "fast-sort";
import IconVideo from "material-ui/svg-icons/av/videocam";
import IconImage from "material-ui/svg-icons/editor/insert-photo";
import ImagePicker from "../../../components/common/ImagePicker";
import VideoPicker from "../../../components/common/VideoPicker";
import FilePicker from "../../../components/common/FilePicker";
import Snackbar from "material-ui/Snackbar";
import UrlUtils from "../../utils/urlUtils";
import "../../../resources/styles/instructions.css";

import NormalFlatButton from "../../../components/common/NormalFlatButton";
import DeleteButton from "../../../components/common/DeleteButton";
import { Editor } from "react-draft-wysiwyg";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import { EditorState, convertToRaw } from "draft-js";
import RichTextEditor from "react-rte";
import { Mixpanel } from "../../../mixpanel";
import {
  getTextAlignBlockMetadata,
  getTextAlignClassName,
  getTextAlignStyles,
} from "./blockStyleFunctions";
import LibraryInstructionPrint from "../LibraryInstructionPrint";
import UUID from "uuid/v4";

const style = {
  page: {
    display: "flex",
    flexFlow: "column",
    justifyContent: "center",
  },
  buttonContainer: {
    width: "100%",
    flex: 1,
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap",
    justifyContent: "center",
  },
  treeButton: {
    marginLeft: 50,
    marginTop: 20,
  },
  nodeAttributes: {
    padding: 4,
    justifyContent: "center",
    marginLeft: 20,
    borderStyle: "solid",
    borderRadius: 4,
    borderWidth: 0.5,
    borderColor: "#d6d7da",
  },
  attribute: {
    margin: 4,
    color: colors.primary,
    fontSize: 14,
    justifyContent: "center",
  },
  textContainer: {
    paddingLeft: 12,
  },
  labelContainer: {
    paddingLeft: 4,
    paddingRight: 12,
  },
  label: {
    color: colors.primary,
    fontSize: 14,
  },
  video: {
    height: 100,
  },
  image: {
    height: 100,
  },
  insBtn: {
    position: "absolute",
    top: "0",
    right: "1px",
  },
  insLabel: {
    fontSize: "16px",
    color: colors.steelBlue,
  },
  newAttachments: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "space-between",
  },
  description: {
    width: "100%",
  },
  error: {
    backgroundColor: "red!important",
  },
  marginleft: {
    marginLeft: "10px",
  },
  marginRight: {
    marginRight: "15px",
  },
  headerRow: {
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap",
    flex: 1,
    justifyContent: "space-between",
  },
  headerTitle: {
    display: "flex",
    flex: 1,
  },
  headerButton: {
    alignSelf: "flex-end",
  },
};

class LibraryManager extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      editorState: EditorState.createEmpty(),
      value: RichTextEditor.createEmptyValue(),
      dataSource: props.dataSource,
      renderingIndex: 0,
      showPrintInstruction: false,
      open: false,
      newInstruction: {
        name: "",
        group: {},
        description: "",
        imageUrl: "",
        videoUrl: "",
        imageAdded: false,
        videoAdded: false,
        defaultReps: "",
        defaultSets: "",
        youtubeVideo: "",
        wistiaVideo: "",
        defaultDuration: "",
        defaultIntensity: "",
        defaultFrequency: "",
        documents: [],
        descriptionWithFormat: "",
      },
      searchText: "",
      notif: {
        open: false,
        message: "",
      },
      updater: 0,
    };
    this.renderContentTree = this.renderContentTree.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.dataSource) {
      this.setState({
        dataSource: nextProps.dataSource,
      });
    }
  }

  // === Node operation (add/remove/update nodes) ===

  // --- Node: Add ---

  onEditorStateChange = (editorState) => {
    this.setState({
      editorState,
    });
    const contentState = editorState.getCurrentContent();
    // console.log(convertToRaw(contentState));
    // const description = convertToRaw(contentState).map(block => (!block.text.trim() && '\n') || block.text).join('\n');
    let description = convertToRaw(contentState)
      .blocks.map((block) => block.text + "\n")
      .join("\n");
    this.setState({
      newInstruction: {
        ...this.state.newInstruction,
        description: description,
        descriptionWithFormat: JSON.stringify(convertToRaw(contentState)),
      },
    });
    // console.log(this.state.newInstruction);
  };

  addCategory(i_header, i_group, categories) {
    let emptyCategory = {
      label: this.props.config.categoryLabel,
      categoryName: "",
    };
    let newCategories = _.slice(categories);
    newCategories.push(emptyCategory);
    let ds = this.state.dataSource;
    ds[i_header].groups[i_group].categories = newCategories;
    this.setState({
      dataSource: ds,
    });
  }

  handleOpen = () => {
    this.setState({ open: true });
  };

  addGroup(i_header, groups) {
    let emptyGroup = {
      label: this.props.config.groupLabel,
      groupName: "",
      categories: [
        {
          label: this.props.config.categoryLabel,
          categoryName: "",
        },
      ],
    };
    let newGroups = _.slice(groups);
    newGroups.push(emptyGroup);
    let ds = this.state.dataSource;
    ds[i_header].groups = newGroups;
    this.setState({
      dataSource: ds,
    });
  }

  // --- Node: Remove ---

  removeCategory(i_header, i_group, i_category, categories) {
    let newCategories = _.slice(categories);
    _.pullAt(newCategories, [i_category]);
    let ds = this.state.dataSource;
    ds[i_header].groups[i_group].categories = newCategories;
    this.setState({
      dataSource: ds,
    });
  }

  removeGroup(i_header, i_group, groups) {
    let newGroups = _.slice(groups);
    _.pullAt(newGroups, [i_group]);
    let ds = this.state.dataSource;
    ds[i_header].groups = newGroups;
    this.setState({
      dataSource: ds,
    });
  }

  // --- Node: Reorder ---

  reorderCategory(i_header, i_group, i_category, categories, direction) {
    let newCategories = _.slice(categories);
    if (direction === "up") {
      if (i_category <= 0) return;
      let temp = newCategories[i_category - 1];
      newCategories[i_category - 1] = newCategories[i_category];
      newCategories[i_category] = temp;
    } else if (direction === "down") {
      if (i_category >= categories.length - 1) return;
      let temp = newCategories[i_category + 1];
      newCategories[i_category + 1] = newCategories[i_category];
      newCategories[i_category] = temp;
    }
    let ds = this.state.dataSource;
    ds[i_header].groups[i_group].categories = newCategories;
    this.setState({
      dataSource: ds,
    });
  }

  reorderGroup(i_header, i_group, groups, direction) {
    let newGroups = _.slice(groups);
    if (direction === "up") {
      if (i_group <= 0) return;
      let temp = newGroups[i_group - 1];
      newGroups[i_group - 1] = newGroups[i_group];
      newGroups[i_group] = temp;
    } else if (direction === "down") {
      if (i_group >= groups.length - 1) return;
      let temp = newGroups[i_group + 1];
      newGroups[i_group + 1] = newGroups[i_group];
      newGroups[i_group] = temp;
    }
    let ds = this.state.dataSource;
    ds[i_header].groups = newGroups;
    this.setState({
      dataSource: ds,
    });
  }

  // --- Node: Update ---

  updateCategory(
    i_header,
    i_group,
    i_category,
    originalCategory,
    updatedValue
  ) {
    let newCategory = _.assign({}, originalCategory, updatedValue);
    let ds = this.state.dataSource;
    ds[i_header].groups[i_group].categories[i_category] = newCategory;
    this.setState({
      dataSource: ds,
    });
  }

  updateGroup(i_header, i_group, originalGroup, updatedValue) {
    let newGroup = _.assign({}, originalGroup, updatedValue);
    let ds = this.state.dataSource;
    ds[i_header].groups[i_group] = newGroup;
    this.setState({
      dataSource: ds,
    });
  }

  handleNewRequest = (chosenRequest, index) => {
    if (index > -1) {
      this.setState({
        newInstruction: {
          ...this.state.newInstruction,
          group: chosenRequest,
        },
      });
    }
  };

  handleUpdateInput = (searchText) => {
    this.setState({
      searchText: searchText,
    });
  };

  handleClose = () => {
    this.setState({
      open: false,
      renderingIndex: this.state.renderingIndex + 1,
      newInstruction: {
        name: "",
        groups: [],
        groupName: [],
        description: "",
      },
    });
  };

  printInstruction(category) {
    this.setState({ category, showPrintInstruction: true }, () => {
      let containerEl = document.createElement("div");
      const input = document.getElementById("divLibraryInstructions");
      let inputClone = input.cloneNode(true);
      input.appendChild(inputClone);
      containerEl.appendChild(inputClone);
      this.externalWindow = window.open(
        "",
        "",
        "width=1000,height=500,left=200,top=200"
      );
      this.externalWindow.document.body.appendChild(containerEl);
      //Trigger automatic print and close window after.
      this.externalWindow.onafterprint = () => {
        this.externalWindow.close();
      };
      this.externalWindow.print();
      this.setState({ showPrintInstruction: false, category: undefined });
    });
  }
  // === Main ===

  sortInstructions = (instructions) => {
    if (instructions) {
      return sort(instructions).asc([(item) => item.categoryName]);
    }
  };
  getAllCategory = () => {
    let categories = [];
    for (let index = 0; index < this.state.dataSource.length; index++) {
      const element = this.state.dataSource[index];
      for (let i = 0; i < element.groups.length; i++) {
        const group = element.groups[i];
        categories.push({
          valueKey: { i_header: index, i_group: i, group },
          textKey: group.groupName,
        });
      }
    }
    return categories;
  };

  addDocument = () => {
    let documents = this.state.newInstruction.documents;
    if (_.isEmpty(documents)) {
      documents = [];
    }
    let emptyDocument = {
      name: "",
      url: "",
    };
    let newDocuments = _.slice(documents);
    newDocuments.push(emptyDocument);

    this.setState({
      newInstruction: { ...this.state.newInstruction, documents: newDocuments },
    });
  };

  updateDocument = (idx, originalDocument, updatedValue) => {
    let newDocument = _.assign({}, originalDocument, updatedValue);
    let updateDocs = this.state.newInstruction.documents;
    updateDocs[idx] = newDocument;
    this.setState({
      newInstruction: { ...this.state.newInstruction, documents: updateDocs },
    });
  };

  removeDocument = (idx) => {
    let documents = this.state.newInstruction.documents;
    let filteredDocs = documents.filter((doc, i) => i !== idx);
    this.setState({
      newInstruction: { ...this.state.newInstruction, documents: filteredDocs },
    });
  };

  checkIsNewCategory = () => {
    let indexOf = this.getAllCategory()
      .map((category) => category["textKey"])
      .indexOf(this.state.searchText);
    return indexOf;
  };

  addNewInstruction = () => {
    if (!this.state.searchText.length) {
      this.setState({
        notif: {
          message: "Check your category!",
          open: true,
        },
      });
      return;
    }

    if (!this.state.newInstruction.name.length) {
      this.setState({
        notif: {
          message: "Check your instruction name!",
          open: true,
        },
      });
      return;
    }

    let indexOfCategory = this.checkIsNewCategory();
    if (indexOfCategory === -1) {
      let emptyCategory = {
        label: this.props.config.groupLabel,
        groupName: this.state.searchText,
        categories: [
          {
            categoryId: UUID(),
            categoryName: this.state.newInstruction.name,
            expanded: false,
            categoryDesc: this.state.newInstruction.description,
            categoryDescWithFormat:
              this.state.newInstruction.descriptionWithFormat,
            createdAt: { nanos: 0, seconds: new Date().getTime() },
            modifiedAt: { nanos: 0, seconds: new Date().getTime() },
          },
        ],
      };
      if (this.state.newInstruction.imageUrl !== "") {
        emptyCategory.categories[0].imageUrl =
          this.state.newInstruction.imageUrl;
      }
      if (this.state.newInstruction.videoUrl !== "") {
        emptyCategory.categories[0].videoUrl =
          this.state.newInstruction.videoUrl;
      }
      if (this.state.newInstruction.youtubeVideo !== "") {
        emptyCategory.categories[0].youtubeVideo =
          this.state.newInstruction.youtubeVideo;
      }
      if (this.state.newInstruction.wistiaVideo !== "") {
        emptyCategory.categories[0].wistiaVideo =
          this.state.newInstruction.wistiaVideo;
      }

      if (this.state.newInstruction.defaultReps !== "") {
        emptyCategory.categories[0].defaultReps =
          this.state.newInstruction.defaultReps;
      }
      if (this.state.newInstruction.defaultSets !== "") {
        emptyCategory.categories[0].defaultSets =
          this.state.newInstruction.defaultSets;
      }
      if (this.state.newInstruction.defaultDuration !== "") {
        emptyCategory.categories[0].defaultDuration =
          this.state.newInstruction.defaultDuration;
      }
      if (this.state.newInstruction.defaultIntensity !== "") {
        emptyCategory.categories[0].defaultIntensity =
          this.state.newInstruction.defaultIntensity;
      }
      if (this.state.newInstruction.defaultFrequency !== "") {
        emptyCategory.categories[0].defaultFrequency =
          this.state.newInstruction.defaultFrequency;
      }

      if (this.state.newInstruction.documents !== "") {
        emptyCategory.categories[0].documents =
          this.state.newInstruction.documents;
      }

      this.state.dataSource[0].groups.push(emptyCategory);
      this.setState({
        open: false,
        renderingIndex: this.state.renderingIndex + 1,
        newInstruction: {
          name: "",
          group: {},
          description: "",
          imageUrl: "",
          videoUrl: "",
          imageAdded: false,
          videoAdded: false,
          wistiaVideo: "",
          youtubeVideo: "",
          defaultReps: "",
          defaultSets: "",
          defaultDuration: "",
          defaultIntensity: "",
          defaultFrequency: "",
          documents: [],
          descriptionWithFormat: "",
        },
        searchText: "",
      });
    } else {
      let i_header = 0;
      let i_group = indexOfCategory;
      let newInstruction = {
        categoryId: UUID(),
        categoryName: this.state.newInstruction.name,
        expanded: false,
        categoryDesc: this.state.newInstruction.description,
        categoryDescWithFormat: this.state.newInstruction.descriptionWithFormat,
        createdAt: { nanos: 0, seconds: new Date().getTime() },
        modifiedAt: { nanos: 0, seconds: new Date().getTime() },
      };
      if (this.state.newInstruction.imageUrl !== "") {
        newInstruction.imageUrl = this.state.newInstruction.imageUrl;
      }

      if (this.state.newInstruction.videoUrl !== "") {
        newInstruction.videoUrl = this.state.newInstruction.videoUrl;
      }

      if (this.state.newInstruction.youtubeVideo !== "") {
        newInstruction.youtubeVideo = this.state.newInstruction.youtubeVideo;
      }
      if (this.state.newInstruction.wistiaVideo !== "") {
        newInstruction.wistiaVideo = this.state.newInstruction.wistiaVideo;
      }

      if (this.state.newInstruction.defaultReps !== "") {
        newInstruction.defaultReps = this.state.newInstruction.defaultReps;
      }
      if (this.state.newInstruction.defaultSets !== "") {
        newInstruction.defaultSets = this.state.newInstruction.defaultSets;
      }
      if (this.state.newInstruction.defaultDuration !== "") {
        newInstruction.defaultDuration =
          this.state.newInstruction.defaultDuration;
      }
      if (this.state.newInstruction.defaultIntensity !== "") {
        newInstruction.defaultIntensity =
          this.state.newInstruction.defaultIntensity;
      }
      if (this.state.newInstruction.defaultFrequency !== "") {
        newInstruction.defaultFrequency =
          this.state.newInstruction.defaultFrequency;
      }

      if (this.state.newInstruction.documents !== "") {
        newInstruction.documents = this.state.newInstruction.documents;
      }

      this.state.dataSource[i_header].groups[i_group].categories.push(
        newInstruction
      );
      Mixpanel.track("Add New Instruction", {
        "Channel Name": this.state.dataSource[0].header,
        "Channel ID": this.props.appId,
        "Instruction Name": this.state.newInstruction.name,
        Platform: "Web",
      });

      this.setState({
        open: false,
        renderingIndex: this.state.renderingIndex + 1,
        newInstruction: {
          name: "",
          group: {},
          description: "",
          imageUrl: "",
          videoUrl: "",
          youtubeVideo: "",
          wistiaVideo: "",
          imageAdded: false,
          videoAdded: false,
          defaultReps: "",
          defaultSets: "",
          defaultDuration: "",
          defaultIntensity: "",
          defaultFrequency: "",
          documents: [],
          descriptionWithFormat: "",
        },
        searchText: "",
      });
    }
  };

  updateInstruction(instruction, groupName, i_header, i_group, i_category) {
    let index = this.getAllCategory()
      .map((category) => category["textKey"])
      .indexOf(groupName);
    let index2 = this.getAllCategory()
      .map((category) => category["textKey"])
      .indexOf(groupName["textKey"]);
    let tempDatasource = [...this.state.dataSource];
    // console.log(index);
    // console.log(i_group);
    if (index !== i_group && index > -1) {
      tempDatasource[i_header].groups[i_group].categories.splice(i_category, 1);
      tempDatasource[i_header].groups[index].categories.push(instruction);
      this.setState({ dataSource: tempDatasource });
    } else if (index === i_group && index > -1) {
      tempDatasource[i_header].groups[i_group].categories[i_category] =
        instruction;
      this.setState({ dataSource: tempDatasource });
    } else if (index2 !== i_group && index2 > -1) {
      tempDatasource[i_header].groups[i_group].categories.splice(i_category, 1);
      tempDatasource[i_header].groups[index2].categories.push(instruction);
      this.setState({ dataSource: tempDatasource });
    } else {
      tempDatasource[i_header].groups[i_group].categories.splice(i_category, 1);
      let emptyCategory = {
        label: this.props.config.groupLabel,
        groupName: groupName,
        categories: [],
      };
      emptyCategory.categories.push(instruction);
      tempDatasource[i_header].groups.push(emptyCategory);
      this.setState({ dataSource: tempDatasource });
    }
    Mixpanel.track("Edit instruction", {
      "Channel Name": this.state.dataSource[0].header,
      "Channel ID": this.props.appId,
      "User ID": this.props.userId,
      "Instruction Name": instruction.categoryName,
      "Instruction ID": instruction.categoryId,
      Platform: "Web",
    });
    this.setState({ renderingIndex: this.state.renderingIndex + 1 });
  }

  deleteInstruction(i_header, i_group, i_category) {
    if (window.confirm("Are you sure you want to delete instruction?")) {
      this.state.dataSource[i_header].groups[i_group].categories.splice(
        i_category,
        1
      );
      this.setState({ updater: this.state.updater++ });
    }
  }

  deleteCategory(i_header, i_group) {
    if (window.confirm("Are you sure you want to delete category?")) {
      this.state.dataSource[i_header].groups.splice(i_group, 1);
      this.setState({ updater: this.state.updater++ });
    }
  }

  imageButtonClicked(e) {
    this.setState({
      newInstruction: {
        ...this.state.newInstruction,
        imageAdded: !this.state.newInstruction.imageAdded,
      },
    });
    process.nextTick(() => {
      if (!this.state.newInstruction.imageAdded) {
        this.setState({
          newInstruction: {
            ...this.state.newInstruction,
            imageUrl: "",
          },
        });
      }
    });
  }

  videoButtonClicked(e) {
    this.setState({
      newInstruction: {
        ...this.state.newInstruction,
        videoAdded: !this.state.newInstruction.videoAdded,
      },
    });
    process.nextTick(() => {
      if (!this.state.newInstruction.videoAdded) {
        this.setState({
          newInstruction: {
            ...this.state.newInstruction,
            videoUrl: "",
          },
        });
      }
    });
  }

  onChange = (value) => {
    this.setState({ value });
    let editorState = this.state.value.getEditorState();
    let contentState = editorState.getCurrentContent();
    // let description = contentState.blockMap && contentState.blockMap.map( block => block.text + '\n').join('\n');
    // console.log(contentState);
    this.setState({
      newInstruction: {
        ...this.state.newInstruction,
        description: contentState.getPlainText(),
        descriptionWithFormat: value.toString("html", {
          blockStyleFn: getTextAlignStyles,
        }),
      },
    });
  };

  renderContentTree() {
    const toolbarConfig = {
      display: [
        "INLINE_STYLE_BUTTONS",
        "BLOCK_TYPE_BUTTONS",
        "BLOCK_TYPE_DROPDOWN",
        "LINK_BUTTONS",
      ],
      INLINE_STYLE_BUTTONS: [
        { label: "Bold", style: "BOLD", className: "custom-css-class" },
        { label: "Italic", style: "ITALIC" },
        { label: "Underline", style: "UNDERLINE" },
      ],
      BLOCK_TYPE_DROPDOWN: [
        { label: "Normal", style: "unstyled" },
        { label: "Heading Large", style: "header-one" },
        { label: "Heading Medium", style: "header-two" },
        { label: "Heading Small", style: "header-three" },
      ],
      BLOCK_TYPE_BUTTONS: [
        { label: "UL", style: "unordered-list-item" },
        { label: "OL", style: "ordered-list-item" },
      ],
    };
    const actions = [
      <FlatButton
        label="Cancel"
        primary={true}
        style={style.marginRight}
        onClick={this.handleClose}
      />,
      <RaisedButton
        primary={true}
        label="Add Instruction"
        icon={<IconAdd />}
        onClick={this.addNewInstruction}
      />,
    ];
    let data = ["12345", "23456", "34567"];
    let dataSourceConfig = {
      text: "textKey",
      value: "valueKey",
    };
    return (
      <div key={this.state.renderingIndex}>
        <Snackbar
          open={this.state.notif.open}
          message={this.state.notif.message}
          autoHideDuration={4000}
          onRequestClose={() =>
            this.setState({ notif: { message: "", open: false } })
          }
          style={style.error}
        />
        <RaisedButton
          primary={true}
          className={"insBtn"}
          label="New Instruction"
          icon={<IconAdd />}
          onClick={this.handleOpen}
        />

        <div key={this.state.updater}>
          <div>
            <Dialog
              actions={actions}
              modal={true}
              open={this.state.open}
              autoScrollBodyContent={true}
              autoDetectWindowHeight={true}
              autoDetectWindowWidth={true}
              style={style.customContentStyle}
              actionsContainerClassName={"dialog-btns"}
            >
              <Title
                text1="Add"
                text2="Instruction"
                goBack={this.handleClose}
              />
              <div className={"ins-counters"}>
                <div className={"ins-counters-item"}>
                  <label style={style.insLabel}>Category:</label>
                  <AutoComplete
                    filter={AutoComplete.noFilter}
                    openOnFocus={true}
                    dataSource={this.getAllCategory()}
                    onUpdateInput={this.handleUpdateInput}
                    dataSourceConfig={dataSourceConfig}
                    onNewRequest={this.handleNewRequest}
                    searchText={this.state.searchText}
                    hintText="Type or select the category name"
                    fullWidth={true}
                    menuStyle={{ maxHeight: 200 }}
                  />
                </div>
                <div className={"ins-counters-item"}>
                  <label style={style.insLabel}>Name:</label>
                  <input
                    placeholder="Instruction Name"
                    onChange={(event) =>
                      this.setState({
                        newInstruction: {
                          ...this.state.newInstruction,
                          name: event.target.value,
                        },
                      })
                    }
                  />
                </div>
                <div className={"ins-counters-item"}>
                  <label style={style.insLabel}>Description:</label>
                  <RichTextEditor
                    blockStyleFn={getTextAlignClassName}
                    value={this.state.value}
                    onChange={this.onChange}
                    toolbarConfig={toolbarConfig}
                    className="wrapper-class-editer"
                    editorClassName="editor-class"
                    toolbarClassName="toolbar-class"
                  />
                </div>
              </div>

              <div style={style.newAttachments}>
                <div className={"newAttachments"}>
                  <div className={"newAttachments-video"}>
                    <FloatingActionButton
                      className={"newAttachments-video-btn"}
                      style={style.marginleft}
                      onClick={(e) => this.videoButtonClicked(e)}
                    >
                      <IconVideo />
                    </FloatingActionButton>
                    {this.state.newInstruction.videoAdded && (
                      <div className={"newAttachments-video-uploader"}>
                        <VideoPicker
                          videoType="library"
                          videoUrl={this.state.newInstruction.videoUrl}
                          userId={this.props.userId}
                          appId={this.props.appId}
                          previewStyle={style.media}
                          hidden={this.state.newInstruction.videoAdded}
                          handleSubmit={(videoUrl) =>
                            this.setState({
                              newInstruction: {
                                ...this.state.newInstruction,
                                videoUrl: videoUrl,
                              },
                            })
                          }
                        />
                      </div>
                    )}
                  </div>
                  <div className={"newAttachments-image"}>
                    <FloatingActionButton
                      className={"newAttachments-image-btn"}
                      onClick={(e) => this.imageButtonClicked(e)}
                    >
                      <IconImage />
                    </FloatingActionButton>
                    {this.state.newInstruction.imageAdded && (
                      <div className={"newAttachments-image-uploader"}>
                        <ImagePicker
                          imageUrl={this.state.newInstruction.imageUrl}
                          userId={this.props.userId}
                          previewStyle={style.media}
                          hidden={this.state.newInstruction.imageAdded}
                          handleSubmit={(imageUrl) =>
                            this.setState({
                              newInstruction: {
                                ...this.state.newInstruction,
                                imageUrl: imageUrl,
                              },
                            })
                          }
                        />
                      </div>
                    )}
                  </div>
                </div>
              </div>
              <div style={style.newAttachments}>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    borderTop: "solid 1px",
                    width: "100%",
                    padding: 10,
                  }}
                >
                  <div style={style.insLabel}>Documents:</div>
                  <NormalFlatButton
                    icon={<IconAdd color={colors.primary} />}
                    label="Add Additional Document"
                    onClick={() => this.addDocument()}
                  />
                  {this.state.newInstruction.documents &&
                    this.state.newInstruction.documents.map((document, idx) => {
                      return (
                        <div>
                          <div style={{ display: "inline-block" }}>
                            <TextField
                              floatingLabelText="Document Name"
                              errorText={
                                _.isEmpty(document.name)
                                  ? "This field is required"
                                  : ""
                              }
                              value={document.name}
                              onChange={(event) => {
                                let name = event.target.value;
                                this.updateDocument(idx, document, { name });
                              }}
                            />
                          </div>
                          {!_.isEmpty(document.url) && (
                            <a
                              href={document.url}
                              target="_blank"
                              alt={"Download " + document.name}
                            >
                              Download
                            </a>
                          )}
                          <div style={{ display: "inline-block" }}>
                            <FilePicker
                              fileUrl={document.url}
                              userId={this.props.userId}
                              appId={this.props.appId}
                              handleSubmit={(fileUrl) => {
                                this.updateDocument(idx, document, {
                                  url: fileUrl,
                                });
                              }}
                            />
                          </div>
                          <div style={{ display: "inline-block" }}>
                            <DeleteButton
                              onClick={() => this.removeDocument(idx)}
                            />
                          </div>
                        </div>
                      );
                    })}
                </div>
              </div>
              <div className={"ins-counters"}>
                <div className={"ins-counters-item"}>
                  <label style={style.insLabel}>YouTube Video:</label>
                  <input
                    placeholder="YouTube Video URL"
                    onChange={(event) =>
                      this.setState({
                        newInstruction: {
                          ...this.state.newInstruction,
                          youtubeVideo: {
                            url: event.target.value,
                            id: UrlUtils.getYoutubeVideoId(event.target.value),
                          },
                        },
                      })
                    }
                  />
                </div>
                <div className={"ins-counters-item"}>
                  <label style={style.insLabel}>Wistia Video:</label>
                  <input
                    placeholder="Wistia Video URL"
                    onChange={(event) =>
                      this.setState({
                        newInstruction: {
                          ...this.state.newInstruction,
                          wistiaVideo: {
                            url: event.target.value,
                            id: UrlUtils.getWistiaVideoId(event.target.value),
                          },
                        },
                      })
                    }
                  />
                </div>
              </div>

              {this.props.templateId === 103 && (
                <div className={"ins-counters"}>
                  <div className={"ins-counters-item"}>
                    <label style={style.insLabel}>Repetitions:</label>
                    <input
                      placeholder="Default Number Of Repetitions"
                      onChange={(event) =>
                        this.setState({
                          newInstruction: {
                            ...this.state.newInstruction,
                            defaultReps: event.target.value,
                          },
                        })
                      }
                    />
                  </div>
                  <div className={"ins-counters-item"}>
                    <label style={style.insLabel}>Sets:</label>
                    <input
                      placeholder="Default Number Of Sets"
                      onChange={(event) =>
                        this.setState({
                          newInstruction: {
                            ...this.state.newInstruction,
                            defaultSets: event.target.value,
                          },
                        })
                      }
                    />
                  </div>
                  <div className={"ins-counters-item"}>
                    <label style={style.insLabel}>Duration:</label>
                    <input
                      placeholder="Default Duration"
                      onChange={(event) =>
                        this.setState({
                          newInstruction: {
                            ...this.state.newInstruction,
                            defaultDuration: event.target.value,
                          },
                        })
                      }
                    />
                  </div>
                  <div className={"ins-counters-item"}>
                    <label style={style.insLabel}>Intensity:</label>
                    <input
                      placeholder="Default Intensity"
                      onChange={(event) =>
                        this.setState({
                          newInstruction: {
                            ...this.state.newInstruction,
                            defaultIntensity: event.target.value,
                          },
                        })
                      }
                    />
                  </div>
                  <div className={"ins-counters-item"}>
                    <label style={style.insLabel}>Frequency:</label>
                    <input
                      placeholder="Default Frequency"
                      onChange={(event) =>
                        this.setState({
                          newInstruction: {
                            ...this.state.newInstruction,
                            defaultFrequency: event.target.value,
                          },
                        })
                      }
                    />
                  </div>
                </div>
              )}
            </Dialog>
          </div>

          {this.state.dataSource.map((header, i_header) => {
            // === Header ===
            return (
              <ContentNode
                key={"header-" + i_header}
                expanded={true}
                className="header"
                onNodeTextChange={(text) => (header.header = text)}
                removeNode={() => {}}
              >
                <div>
                  {header.groups.map((group, i_group) => {
                    if (group.categories.length) {
                      return (
                        <CategoryLibrary
                          key={"header2-" + i_group}
                          nodeText={group.groupName}
                          deleteCategory={() =>
                            this.deleteCategory(i_header, i_group)
                          }
                        >
                          {this.sortInstructions(group.categories).map(
                            (category, i_category) => {
                              return (
                                <InstructionLibrary
                                  category={category}
                                  allCategories={this.getAllCategory()}
                                  showAllFields={this.props.templateId === 103}
                                  groupName={group.groupName}
                                  userId={this.props.userId}
                                  appId={this.props.appId}
                                  printInstruction={(category) =>
                                    this.printInstruction(category)
                                  }
                                  updateInstruction={(ins, groupName) =>
                                    this.updateInstruction(
                                      ins,
                                      groupName,
                                      i_header,
                                      i_group,
                                      i_category
                                    )
                                  }
                                  deleteInstruction={() =>
                                    this.deleteInstruction(
                                      i_header,
                                      i_group,
                                      i_category
                                    )
                                  }
                                />
                              );
                            }
                          )}
                        </CategoryLibrary>
                      );
                    }
                  })}
                </div>
              </ContentNode>
            );
          })}
        </div>
        <div className={"save-box"}>
          <NormalBigButton
            onClick={() => this.props.cancelAction()}
            label="Cancel"
            buttonWidth="280"
          />
          <ActionButton
            onClick={() => this.props.saveAction(this.state.dataSource)}
            label="Save"
          />
        </div>

        {this.state.showPrintInstruction && (
          <LibraryInstructionPrint
            category={this.state.category}
            id="divLibraryInstructions"
          />
        )}
      </div>
    );
  }

  render() {
    return <div>{this.renderContentTree()}</div>;
  }
}

LibraryManager.propTypes = {
  dataSource: PropTypes.array.isRequired,
  saveAction: PropTypes.func.isRequired,
  cancelAction: PropTypes.func.isRequired,
  userId: PropTypes.number.isRequired,
  appId: PropTypes.string.isRequired,
  config: PropTypes.object.isRequired,
};

export default LibraryManager;



// WEBPACK FOOTER //
// ./src/layout/playbook/library/LibraryManager.js